import axios from 'axios';
import { BaseHttpClient } from '../BaseHttpClient';
import { injectCommonInterceptors } from '../interceptors';
import {
  SandboxConfigListResponse,
  SandboxConfigResponse,
  SaveSandboxConfigRequest,
  SaveSandboxConfigResponse,
} from './api.schema';
import { BASE_URL } from './consts';

const axiosSandboxConfigInstance = axios.create({
  baseURL: BASE_URL,
});

injectCommonInterceptors(axiosSandboxConfigInstance);

/**
 * Client for the platform `sandbox_config` module. Auth is the portal user's
 * JWT, attached automatically by the common interceptors — no workspace header.
 *
 * The `config` payload is snake_case and is sent/received raw: no case
 * transformer runs over request bodies or responses here.
 */
export class SandboxConfigClient extends BaseHttpClient {
  constructor() {
    super(axiosSandboxConfigInstance, {
      defaultExtractNestedData: false,
    });
  }

  static override instance = new SandboxConfigClient();

  static async listConfigs() {
    return await SandboxConfigClient.get<SandboxConfigListResponse>('/configs');
  }

  static async getConfig(name: string) {
    return await SandboxConfigClient.get<SandboxConfigResponse>(
      `/configs/${encodeURIComponent(name)}`,
    );
  }

  static async saveConfig(body: SaveSandboxConfigRequest) {
    return await SandboxConfigClient.post<SaveSandboxConfigResponse>(
      '/configs',
      body,
    );
  }

  static async deleteConfig(name: string): Promise<void> {
    await SandboxConfigClient.delete<void>(
      `/configs/${encodeURIComponent(name)}`,
    );
  }
}
